import { GridRow, GridRowProps } from "@mui/x-data-grid";
import { Box } from "src/components/MuiGenerals";
import AggregationRow from "../components/AggregationRow";
import { CSSProperties } from "react";

export type AggregationField = {
  field: string; // column field of DataGrid
  value: React.ReactNode; // value to display in the aggregation row
  padding?: CSSProperties["padding"]; // padding for the cell
  hasTooltip?: boolean; // whether to show tooltip for the cell
  color?: CSSProperties["color"]; // text color for the cell
};

function renderRowWithAggregation({
  params,
  totalRowCount,
  rowHeight = 50,
  fields,
}: {
  params: GridRowProps;
  totalRowCount: number;
  rowHeight?: number;
  fields: AggregationField[];
}) {
  if (params.index + 1 !== totalRowCount) {
    return <GridRow {...params} />;
  }

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <GridRow {...params} />

      <AggregationRow
        fields={params.visibleColumns.map((col) => {
          const {
            padding = "0 10px",
            value = null,
            hasTooltip = false,
            color = "inherit",
          } = fields.find((f) => f.field === col.field) || {};

          return {
            field: col.field,
            value,
            width: col.computedWidth,
            align: col.align || "center",
            height: rowHeight,
            padding,
            hasTooltip,
            color,
          };
        })}
      />
    </Box>
  );
}

export default renderRowWithAggregation;
